import { render } from "./price-item.vue?vue&type=template&id=4d77fca6"
import script from "./price-item.vue?vue&type=script&lang=js"
export * from "./price-item.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__